import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasRoles } from '../../auth/hasRoles';

export function DashboardRoute() {
  const role = hasRoles();
  if (
    role === 'user' ||
    role === 'appel_offre' ||
    role === 'commercial' ||
    role === 'projet' ||
    role === 'intervention' ||
    role === 'gestion_psy' ||
    role === 'administrateur'
  ) {
    return <Outlet />;
  }
  return <Navigate to="/specialists" replace />;
}
